import { type RouteConfig } from 'vue-router'
import Debug from '@/pages/debug.vue'
import Home from '@/pages/home.vue'
import Chapter from '@/pages/chapter.vue'
import Finished from '@/pages/finished.vue'
import Authorize from '@/pages/authorize.vue'
import Error from '@/pages/error.vue'
import NotFound from '@/pages/404.vue'

const routes: Array<RouteConfig> = [
  { path: '/debug', name: 'debug', component: Debug, meta: { title: 'DEBUG', requiresAuth: false } },
  { path: '/content/:contentId/:chapterId', name: 'chapter', component: Chapter, meta: { title: '章节详情' }, props: true },
  { path: '/finished/:contentId', name: 'finished', component: Finished, meta: { title: '连载完结推荐' }, props: true },
  { path: '/authorize', name: 'authorize', component: Authorize, meta: { title: '授权中', requiresAuth: false }, props: route => ({ redirect: route.query.redirect, appId: route.query.appId, code: route.query.code, state: route.query.states }) },
  { path: '/500', name: 'error', component: Error, meta: { title: '服务器错误', requiresAuth: false }, props: route => ({ level: route.query.level }) },
  { path: '*', name: 'notFound', alias: '/404', component: NotFound, meta: { title: '404', requiresAuth: false } },
]

if (import.meta.env.MODE !== 'production') {
  // Note: Add home page for testing
  routes.push({ path: '/', name: 'home', component: Home, meta: { title: '书城' }, props: true })
}

export default routes
